import { Fragment, type ReactNode } from 'react';
import { ChildListSchema, DynamicStringSchema } from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { CreateQuote } from './CreateQuote';

interface ResolvedProps {
  readonly accountName: string;
  readonly submissionNumber?: string;
  /** Child CreateQuoteRow component IDs, in display order. */
  readonly children?: readonly string[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  accountName: DynamicStringSchema,
  submissionNumber: DynamicStringSchema,
  children: ChildListSchema,
}) as any;

export const CreateQuoteImpl = createComponentImplementation(
  { name: 'CreateQuote', schema },
  ({
    props,
    buildChild,
  }: {
    props: ResolvedProps;
    buildChild: (childId: string) => ReactNode;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    context: any;
  }) => (
    <CreateQuote
      accountName={props.accountName ?? ''}
      submissionNumber={props.submissionNumber}
    >
      {(Array.isArray(props.children) ? props.children : []).map((childId) => (
        <Fragment key={childId}>{buildChild(childId)}</Fragment>
      ))}
    </CreateQuote>
  )
);
